module.exports = __webpack_public_path__ + "static/media/logo_tetrice.aa32da7b.png";